import React, { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import Field from '../../features/receivement/pages/NewReceivement/components/Field'
import Fieldset from '../../features/receivement/pages/NewReceivement/components/Fieldset'
import Form from '../../features/receivement/pages/NewReceivement/components/Form'
import Submit from '../../features/receivement/components/Submit'
import { validateSupervisorBadge } from '../../services/receivement/receivementService'
import * as S from './style'

export const SupervisorLogin = ({ title, handleBadgeInput }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const onSubmit = useCallback(async (data) => {
    const result = await validateSupervisorBadge(data.badge)
    if (result.isOk) {
      handleBadgeInput(data.badge)
    } else {
      toast.error('Falha ao validar o crachá do supervisor!')
    }
  },[handleBadgeInput])

  return (
    <S.Wrapper>
      <S.P>{title}</S.P>
      <S.UserIcon />
      <S.WrapperForm>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Fieldset>
            <Field
              {...register('badge', { required: true })}
              error={errors?.badge}
              text="Crachá do supervisor"
              placeholder="*****************"
              type="password"
              autoFocus
              flexWeight={2}
            />
            <S.Button type="submit" name="validar">
              Validar
            </S.Button>
          </Fieldset>
          <Fieldset>
          </Fieldset>
        </Form>
      </S.WrapperForm>
    </S.Wrapper>
  )
}
